/* eslint-disable react/prop-types */

import React from 'react'

import { IoSearch } from "react-icons/io5";
import format from "date-fns/format";

import { Collapse } from "components/Collapse";
import { FormSearchCars } from "components/FormSearchCars";
import Button from "components/Button";

import { DivContentCar } from "./styles";

import { useApp } from "contexts/AppContext";

export function SearchBarCars({info, handleInfo, searchCars}) {

    const { carState } = useApp()
    const { locationPickupCar, locationDropOffCar, datesSearchCar } = carState

    return (
        <div className="container-search-bar pt-custom border-bottom">
            {info && (
                <>
                    <DivContentCar>
                        <p className="label">Retirada</p>

                        <div className="info">
                            <div className="date d-flex gap-2">
                                <span>{ datesSearchCar.startDate ? format(datesSearchCar.startDate, 'dd/MM/yy') : '-' }</span>
                                <span>{ datesSearchCar.startDate && format(datesSearchCar.startDate, 'HH:mm') }</span>
                            </div>
                            <span className="local">{locationPickupCar?.id ?? '-'}</span>
                        </div>

                        <p className="label">Devolução</p>

                        <div className="info">
                            <div className="date d-flex gap-2">
                                <span>{ datesSearchCar.endDate ? format(datesSearchCar.endDate, 'dd/MM/yy') : '-' } </span>
                                <span>{ datesSearchCar.endDate && format(datesSearchCar.endDate, 'HH:mm') }</span>
                            </div>
                            <span className="local">{locationDropOffCar?.id ?? locationPickupCar?.id}</span>
                        </div>
                    </DivContentCar>

                    <div className="d-flex justify-content-center mb-3">
                        <Button width="200px" onClick={handleInfo} data-bs-toggle="collapse"
                                data-bs-target="#filter-collapse" aria-expanded="false" aria-controls="filter-collapse">
                            <IoSearch className="me-2"/> REFAZER BUSCA
                        </Button>
                    </div>
                </>
            )}

            <Collapse handleClick={handleInfo}>
                <p className="fw-bolder pt-3">Locação de Carros</p>

                    <FormSearchCars />

                    <div className="d-flex justify-content-center mb-4">
                        <Button onClick={() => searchCars(true)} width="200px">
                            <IoSearch className="me-2"/> REFAZER BUSCA
                        </Button>
                    </div>
            </Collapse>
        </div>
    )
}
